import React, { useState, useEffect, useCallback, useRef } from "react";

// Desktop : 5 images
// Astuce : encodeURI gère les espaces/accents présents dans les noms de fichiers.
const desktopImages: string[] = [
  "/images/bannier/1 BANNIERE SITE YEKSINA.jpg",
  "/images/bannier/2 Bannière site Yeksina Home - Carreau THYANA_1.jpg",
  "/images/bannier/3 Bannière site Yeksina Home - Carreau THYANA_2.jpg",
  "/images/bannier/4 Bannière site Yeksina Home 1.jpg",
  "/images/bannier/5 Bannière site Yeksina Home 2.jpg",
].map((path) => encodeURI(path));

// Mobile / Tablette : 5 images
const mobileImages: string[] = [
  "/images/bannier/1 BANNIERE SITE YEKSINA - MOBILE.jpg",
  "/images/bannier/2 Bannière site Yeksina Home - Carreau THYANA_1 MOBILE.jpg",
  "/images/bannier/3 Bannière site Yeksina Home - Carreau THYANA_2 MOBILE.jpg",
  "/images/bannier/4 Bannière site Yeksina Home 1 MOBILE.jpg",
  "/images/bannier/5 Bannière site Yeksina Home 2 MOBILE.jpg",
].map((path) => encodeURI(path));

const AUTOPLAY_DELAY = 5000;
const MOBILE_BREAKPOINT = 1024;

function BannerHomepage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [ratio, setRatio] = useState<number | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const images = isMobile ? mobileImages : desktopImages;

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  useEffect(() => {
    setCurrentIndex(0);
  }, [isMobile]);

  useEffect(() => {
    if (!isMobile) {
      setRatio(null);
      return;
    }
    const img = new Image();
    img.src = images[currentIndex];
    img.onload = () => {
      setRatio(img.naturalWidth / img.naturalHeight);
    };
  }, [currentIndex, isMobile, images]);

  const goToNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  }, [images.length]);

 
  const resetAutoplay = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(goToNext, AUTOPLAY_DELAY);
  }, [goToNext]);

  useEffect(() => {
    resetAutoplay();
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [currentIndex, resetAutoplay]);

  const goToSlide = useCallback((index: number) => {
    setCurrentIndex(index);
  }, []);

  return (
    <section
      className="section-banner-homepage"
      aria-roledescription="carousel"
      aria-label="Bannière d'accueil"
      style={isMobile && ratio ? { aspectRatio: `${ratio}` } : undefined}
    >
      <div className="banner-carousel-track">
        {images.map((src, index) => (
          <div
            key={src}
            className={"banner-carousel-slide" + (index === currentIndex ? " is-active" : "")}
            style={{ backgroundImage: `url(${src})` }}
            aria-hidden={index !== currentIndex}
          />
        ))}
      </div>

      <div className="banner-carousel-dots" role="tablist" aria-label="Choisir une slide">
        {images.map((_, index) => (
          <button
            key={index}
            type="button"
            role="tab"
            aria-selected={index === currentIndex}
            aria-label={`Aller à la slide ${index + 1}`}
            className={"banner-carousel-dot" + (index === currentIndex ? " is-active" : "")}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </section>
  );
}

export default BannerHomepage;